import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { BillingPaymentMethod } from "@/types/billing-transactions";
import { useTranslation } from "react-i18next";

const BillingTransactionPaymentMethodField = ({
  value,
  onChange,
  label,
  error,
  withLabel = true,
  triggerClassName,
}: {
  value?: BillingPaymentMethod | "all methods";
  onChange: (value: BillingPaymentMethod | "all methods") => void;
  label?: string;
  error?: string;
  withLabel?: boolean;
  triggerClassName?: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="min-w-0">
      {withLabel && (
        <label className="mb-1 text-sm font-medium text-gray-700">
          {label || t("billing.paymentMethod")}
        </label>
      )}

      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          className={`w-full flex justify-between border-2 focus:ring-0 focus:border-black hover:border-black ${triggerClassName ?? ""} ${
            error ? "border-red-500" : "border-black"
          }`}
        >
          <SelectValue placeholder={t("billing.allPaymentMethods")} />
        </SelectTrigger>

        <SelectContent>
          <SelectItem value="all methods">
            {t("billing.allPaymentMethods")}
          </SelectItem>
          <SelectItem value={BillingPaymentMethod.ONLINE}>
            {t("billing.paymentMethodOnline")}
          </SelectItem>
          <SelectItem value={BillingPaymentMethod.OFFLINE}>
            {t("billing.paymentMethodOffline")}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default BillingTransactionPaymentMethodField;
